module.exports = __webpack_public_path__ + "img/V48.ecf8d0cc.jpg";